import React from "react"
import { Button, Paper, Typography } from "@mui/material"
import { CloudUpload } from "@mui/icons-material"

interface Props {
  title?: string
  onUploadClick: () => void
}

const EmptyUploadPlaceholder: React.FC<Props> = ({ onUploadClick, title }) => (
  <Paper variant="outlined" sx={{ p: 8, textAlign: "center", borderStyle: "dashed", borderRadius: 2 }}>
    <CloudUpload sx={{ fontSize: 56, color: "text.disabled", mb: 2 }} />
    <Typography variant="h6" color="text.secondary" gutterBottom>
      {title || "No images uploaded yet"}
    </Typography>
    <Typography variant="body2" color="text.disabled" mb={3}>
      Upload or drag and drop one image per product. Selecting multiple images will create multiple products.
    </Typography>
    <Button variant="outlined" startIcon={<CloudUpload />} onClick={onUploadClick}>
      Upload Images
    </Button>
  </Paper>
)

export default EmptyUploadPlaceholder
